import { render, staticRenderFns } from "./xieyi.vue?vue&type=template&id=6dcf90b1&"
import script from "./xieyi.vue?vue&type=script&lang=js&"
export * from "./xieyi.vue?vue&type=script&lang=js&"
import style0 from "./xieyi.vue?vue&type=style&index=0&id=6dcf90b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports